var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListenerBehaviour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 65,
    viewBox: "0 0 188 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 65H188V32.6125C187.971 29.1974 187.264 25.8224 185.921 22.6856C184.577 19.5488 182.623 16.7135 180.174 14.3459L180.123 14.2957C176.765 10.9093 165.544 2.31493 153.933 3.04363C147.8 3.42739 142.549 6.39831 138.327 11.874C125.183 28.9245 107.918 23.169 98.7966 18.2208C90.7577 13.8591 82.548 11.8119 74.3939 12.1377C62.9739 12.5865 46.9002 16.8151 35.1778 34.4115C30.7005 41.1269 20.9636 50.2424 1.38088e-05 55.5995L0 65Z",
    fill: "#F9A826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 17C76.433 17 78 15.433 78 13.5C78 11.567 76.433 10 74.5 10C72.567 10 71 11.567 71 13.5C71 15.433 72.567 17 74.5 17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 7C149.433 7 151 5.433 151 3.50001C151 1.56701 149.433 0 147.5 0C145.567 0 144 1.56701 144 3.50001C144 5.433 145.567 7 147.5 7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 27C112.433 27 114 25.433 114 23.5C114 21.567 112.433 20 110.5 20C108.567 20 107 21.567 107 23.5C107 25.433 108.567 27 110.5 27Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33C40.2091 33 42 31.2091 42 29C42 26.7909 40.2091 25 38 25C35.7909 25 34 26.7909 34 29C34 31.2091 35.7909 33 38 33Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 21C185.433 21 187 19.2091 187 17C187 14.7909 185.433 13 183.5 13C181.567 13 180 14.7909 180 17C180 19.2091 181.567 21 183.5 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenerBehaviour);
export default __webpack_public_path__ + "static/media/ListenerBehaviour.0589d67c04d661c90bf5926c25f61f3a.svg";
export { ForwardRef as ReactComponent };